"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _weirDls = require("@weirgroup/weir-dls");
const iconStyle = {
  paddingRight: 5,
  verticalAlign: 'middle'
};
const UserCard = _ref => {
  var _userData$userFirstNa, _userData$userFirstNa2, _userData$userLastNam, _userData$userLastNam2;
  let {
    userData
  } = _ref;
  const userFirstName = (_userData$userFirstNa = userData === null || userData === void 0 || (_userData$userFirstNa2 = userData.userFirstName) === null || _userData$userFirstNa2 === void 0 ? void 0 : _userData$userFirstNa2.value) !== null && _userData$userFirstNa !== void 0 ? _userData$userFirstNa : '';
  const userLastName = (_userData$userLastNam = userData === null || userData === void 0 || (_userData$userLastNam2 = userData.userLastName) === null || _userData$userLastNam2 === void 0 ? void 0 : _userData$userLastNam2.value) !== null && _userData$userLastNam !== void 0 ? _userData$userLastNam : '';
  const Context = () => {
    var _userData$userEmail$v, _userData$userEmail;
    return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_weirDls.Icon, {
      name: "Mail",
      size: "16px",
      color: "#72808a",
      style: iconStyle
    }), (_userData$userEmail$v = userData === null || userData === void 0 || (_userData$userEmail = userData.userEmail) === null || _userData$userEmail === void 0 ? void 0 : _userData$userEmail.value) !== null && _userData$userEmail$v !== void 0 ? _userData$userEmail$v : '');
  };
  return /*#__PURE__*/_react.default.createElement(_weirDls.TitleContextCard, {
    title: /*#__PURE__*/_react.default.createElement("div", {
      "data-test": "completed-access-requests-username"
    }, userFirstName, " ", userLastName),
    context: /*#__PURE__*/_react.default.createElement(Context, null)
  });
};
exports.UserCard = UserCard;